<template>
<div>
  <section class="registerbox " >
    <div class="formHeader" style="height:50px;line-height:50px;background:	#333">
      <div style="float:left; padding-top:7px;">
        <h5 class="title is-5" style="color:#fff;padding-left:10px;margin-top:5px"><b>Download Previous Day MIS Report</b></h5>
      </div>
    </div>
    <div class="box">
      <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
        <div class="columns">
            <div class="column">
                <div class="field is-horizontal">
                  <div class="field-label ">
                    <label class="label">Select Client :</label>
                  </div>
                  <div class="field-body" align="left">
                    <div class="field">
                      <div class="select ">
                        <select name="hub" id="hub" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.hub') }" style="width:307px;">
                                                <option :value="selected">-- Select Client --</option>
                                                <option :value="cdata.accesstokenkey" v-for="cdata in clientdata">{{ cdata.clientname }}</option>
                                            </select>
                      </div>
                      <span v-show="errors.has('form-1.hub')" class="help is-danger">{{ errors.first('form-1.hub') }}</span>
                    </div>
                  </div>
               </div>

           </div>
          <div class="column" align="left" style="margin-left: -245px;">
            <button class="button is-info" type="submit" @click="downloadCSV">Download MIS Report</button>
          </div>


        </div>

      </form>
    </div>



  </section>
</div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
export default {
  data: function() {
    return {
      data: [],
      showdata: [],
      selectDateFrom: new Date(),
      selectDateTo:new Date(),
      hubdata:[],
        clientdata: []
    };
  },
  computed: {},
  created: function() {
    this.displayHubdata();
    this.displayclient();
  },
  methods: {
    validateForm(scope) {},
    displayclient: function() {
      this.$http.post(`${CONSTANTS.API_URL}/clientmastergetall`)
        .then((result) => {
          this.clientdata = result.body
        })
        .catch((ex) => {
          alert(ex)
        })
    },
    getDownloadCsvObject: function(result) {
      var csvData = result;
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      var data, filename, link;
      filename = "MISReport_" + today + ".csv";
      var csv = this.convertArrayOfObjectsToCSV({
        data: csvData
      });
      if (csv == null) return;
      filename = filename || "export.csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.removeChild(link);
    },
    downloadCSV: function() {
    //  //var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
    //  var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
      var access_token_key = document.getElementById("hub").value;
      var csvObj = {
        access_token_key: `${access_token_key}`
      };
    // console.log(csvObj);
      this.$http
        .post(
          `${CONSTANTS.API_URL}/P2PReports/GetPreviousDayMisReport`,
          csvObj
        )
        .then(result => {
          if (result.data.returnmsg == "successful") {
            this.getDownloadCsvObject(result.data.returnvalue);
            alert("MIS Report Downloaded Successfully");
          } else {
            alert(result.body.returnmsg);
          }
        })
        .catch(ex => {
          console.log("error-----", ex);
        });
    },
    showCSV: function() {
      var center = this.hubid;
      if(center == undefined){
          alert("Please select center");
      }else{
        var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
        var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
        var csvObj = {
          fromdate: `${fromdate}`,
          todate:`${formatdateto}`,
          serviceid: `${this.hubid}`
        };
        if(formatdateto< fromdate){
               alert('To date need to be grater than From date')
        }
        this.$http.post(`${CONSTANTS.API_URL}/P2PReports/GetMisReport`, csvObj)
          .then(result => {
            if (result.body.returnmsg && result.body.returnmsg === 'NoRecordsFound') {
              this.showdata = []
              alerty('Result not found')
            } else if (result.body.length === 0) {
              this.showdata = []
              alert('Result not found')
            } else if (result.body.returnmsg === 'error') {
              this.showdata = []
              alert(result.body.returnvalue)
            } else {
                this.showdata = result.body.returnvalue;
            }
          })
          .catch(ex => {
            console.log("error-----", ex);
          });
      }
    },
    convertArrayOfObjectsToCSV: function(args) {
       var result, ctr, keys, columnDelimiter, lineDelimiter, data;
       data = args.data || null;
       if (data == null || !data.length) {
         return null;
       }
       columnDelimiter = args.columnDelimiter || ",";
       lineDelimiter = args.lineDelimiter || "\n";
       keys = Object.keys(data[0]).slice(0,-1);
       result = "";
       result += keys.join(columnDelimiter);
       result += lineDelimiter;
       data.forEach(function(item) {
       var logdata = item['logdata'];
       //var attempt = item['attempt'];

        item['ordereddate'] =  ""+item['ordereddate'];
        item['manifesteddate'] =  ""+item['ordereddate'];
        item['firstshippeddate'] = null;
        item['secondshippeddate'] = null;
        item['thirdshippeddate'] = null;
        item['firstattemptdate'] = null;
        item['secondattemptdate'] = null;
        item['thirdattemptdate'] = null;
        item['deliverytime'] = null;
        item['firstndrreason'] = null;
        item['secondndrreason'] = null;
        item['thirdndrreason'] = null;

        if(logdata!==null){

           logdata.forEach(function(itm){
             let mydate = new Date(itm.createddate);
             let month=mydate.getMonth()+1;
             let createddate=""+mydate.getFullYear()+"-"+month+"-"+mydate.getDate()+" "+mydate.getHours()+":"+mydate.getMinutes();
             switch(itm.process) {
               case 'BookingDone':

                   if(itm.attempt == 1)
                   {
                      item['firstattemptdate'] = createddate.toString();
                      break;
                    }else if(itm.attempt == 2)
                    {
                        item['secondattemptdate'] = createddate.toString();
                        break;
                    }else if(itm.attempt == 3){
                        item['thirdattemptdate'] = createddate.toString();
                        break;
                    }else {
                      break;
                    }

                case 'Reallocate':
                  if(itm.attempt == 1)
                  {
                     item['firstattemptdate'] = createddate.toString();
                     break;
                   }else if(itm.attempt == 2)
                   {
                       item['secondattemptdate'] = createddate.toString();
                       break;
                   }else if(itm.attempt == 3){

                     item['thirdattemptdate'] = createddate.toString();
                     break;
                   }else {
                     break;
                   }

                case 'NDR':
                    var comment = itm.comments;
                    var result_comment = comment.split("-");
                    if(result_comment)
                    {
                       var ndrreason = result_comment[1];
                    }else {
                        var ndrreason = "";
                    }

                     if(itm.attempt == 1)
                     {
                        item['firstndrreason'] = ndrreason;
                        break;
                      }else if(itm.attempt == 2)
                      {
                          item['secondndrreason'] =  ndrreason;
                          break;
                      }else if(itm.attempt == 3){

                        item['thirdndrreason'] =  ndrreason;
                        break;
                      }else {
                        break;
                      }
               case 'SHIPPED':
                     if(itm.attempt == 0)
                     {
                         item['firstshippeddate'] = createddate.toString();
                         break;
                      }else if(itm.attempt == 1)
                      {
                          item['firstshippeddate'] =  createddate.toString();
                          break;
                      }else if(itm.attempt == 2){

                        item['secondshippeddate'] =  createddate.toString();
                        break;
                      }else if(itm.attempt == 3){

                        item['thirdshippeddate'] =  createddate.toString();
                        break;
                      }else {
                        break;
                      }

               case 'DLV':
                 item['deliverytime'] = createddate.toString();
                 break;
             }
           });
         } else {
           item['deliverytime'] = '';
           item['firstshippeddate'] = '';
           item['secondshippeddate'] = '';
           item['thirdshippeddate'] = '';
           item['firstattemptdate'] = '';
           item['secondattemptdate'] ='';
           item['thirdattemptdate'] = '';
           item['deliverytime'] = '';
           item['firstndrreason'] = '';
           item['secondndrreason'] = '';
           item['thirdndrreason'] = '';
         }


         ctr = 0;
         keys.forEach(function(key) {
           if (ctr > 0) result += columnDelimiter;
           if (item[key] != null) {
             result += '"' + item[key] + '"';
           }
           ctr++;
         });
         result += lineDelimiter;
       });
       return result;
     },
    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
    displayHubdata: function() {

      const deliveryagentobj = {}
      this.$http.post(`${CONSTANTS.API_URL}/P2PReports/GetAllHubListMaster`)
        .then(result => {
          this.hubdata = result.body.returnvalue;
        })
        .catch(ex => {
          console.log('error-----', ex)
        });

      }
  }
};
</script>

<style lang="css">
.popover-container {
  width: 100%;
}
.popover-container input {
  -moz-appearance: none;
  -webkit-appearance: none;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 3px;
  -webkit-box-shadow: none;
  box-shadow: none;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 1rem;
  height: 2.25em;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  line-height: 1.5;
  padding-bottom: calc(0.375em - 1px);
  padding-left: calc(0.625em - 1px);
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
  position: relative;
  vertical-align: top;
  background-color: white;
  border-color: #dbdbdb;
  color: #363636;
  -webkit-box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  max-width: 100%;
  width: 100%;
}
.table tr th {
  color: #fff !important;
}
.table thead,
.table thead tr:hover {
  background: #333 !important;
}
.table button {
  background: #b0c4de !important;
  color: #000 !important;
}
.table tr:hover {
  background: #efefef;
}
tbody tr:nth-child(even) {
  background: #f2f2f2;
}
tbody tr:nth-child(odd) {
  background: #fff;
}
.registerbox {
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  width: 1244px;
  background-color: #fff;
}
hr {
  margin-bottom: 0px;
}
.error {
  color: red;
}
button.editbtn {
  border: none;
  background: transparent !important;
}
.label {
  text-align: left;
}
.select {
  width: 100%;
}
</style>
